<template>
  <div></div>
</template>

<script>
import main from '@/main'
export default {
  data () {
    return {
      dialog: true
    }
  },
  created () {

  }
}
</script>
